import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/main.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "./dev";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <DevSupport ComponentPreviews={ComponentPreviews}
                    useInitialHook={useInitial}
        >
            <App/>
        </DevSupport>
    </React.StrictMode>
);

reportWebVitals();